import { Box, Skeleton } from '@alice-financial/pretext-ui'
import * as React from 'react'

export type PlaceholderProps = {
  mount: Promise<(domElement: string | HTMLElement) => void> | undefined
  id: string
}
// useful when we need to provide an HTML element that will become the mount for
// a stripe element
export const StripeElementPlaceholder = ({ mount, id }: PlaceholderProps) => {
  const [isMounted, setIsMounted] = React.useState(false)
  const ref = React.useRef<HTMLDivElement>(null)
  React.useLayoutEffect(() => {
    const currentEl = ref.current
    if (!mount || isMounted || !currentEl) return
    mount.then((mount) => {
      mount(currentEl)
      setIsMounted(true)
    })
  }, [id, mount, isMounted])
  return (
    <Box ref={ref} id={id}>
      <Skeleton width="100%" />
    </Box>
  )
}
